import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useCallback, useMemo } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { Chip, CircularProgress, MenuItem, Paper, TextField, Typography } from '@material-ui/core';
import { Cancel as CancelIcon } from '@material-ui/icons';
import { FieldType } from '../Form.models';
import classnames from 'classnames';
import { useDeepEffect } from '../../../utils/hooks';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';

function NoOptionsMessage(props) {
  var children = props.children,
      innerProps = props.innerProps,
      _props$selectProps = props.selectProps,
      classes = _props$selectProps.classes,
      slim = _props$selectProps.slim;
  return React.createElement(Typography, Object.assign({
    color: 'textSecondary',
    variant: slim ? 'body2' : 'body1',
    className: slim ? classes.autocompleteNoOptionsMessageSlim : classes.autocompleteNoOptionsMessage
  }, innerProps), children);
}

function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return React.createElement("div", Object.assign({
    ref: inputRef
  }, props));
}

function Control(props) {
  var children = props.children,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      _props$selectProps2 = props.selectProps,
      classes = _props$selectProps2.classes,
      TextFieldProps = _props$selectProps2.TextFieldProps,
      slim = _props$selectProps2.slim,
      labelWidth = _props$selectProps2.labelWidth,
      isFocused = props.isFocused,
      hasValue = props.hasValue;
  var isShrink = isFocused || hasValue;
  return React.createElement(TextField, Object.assign({}, TextFieldProps, {
    fullWidth: true,
    variant: 'outlined',
    className: classes.autocompleteControl,
    InputProps: {
      labelWidth: labelWidth,
      inputComponent: inputComponent,
      inputProps: _objectSpread({
        className: classnames(classes.autocompleteInput),
        ref: innerRef,
        children: children
      }, innerProps),
      classes: {
        notchedOutline: classes.notchedOutline,
        disabled: classes.disabledInput
      }
    },
    InputLabelProps: _objectSpread({}, TextFieldProps.InputLabelProps, {
      shrink: isShrink,
      classes: {
        root: classnames(classes.label, labelWidth ? classnames(classes.clippedLabel, classes.clippedLabelWithAdornment) : '', slim ? classes.slimOutlinedLabel : classes.baseOutlinedLabel),
        shrink: classes.shrinkLabel
      }
    })
  }));
}

function Option(props) {
  var _classnames;

  var innerRef = props.innerRef,
      isFocused = props.isFocused,
      innerProps = props.innerProps,
      children = props.children,
      isSelected = props.isSelected,
      _props$selectProps3 = props.selectProps,
      classes = _props$selectProps3.classes,
      slim = _props$selectProps3.slim;
  return React.createElement(MenuItem, Object.assign({
    ref: innerRef,
    selected: isFocused,
    dense: true,
    component: 'div',
    className: classnames(classes.autocompleteItem, (_classnames = {}, _defineProperty(_classnames, classes.autocompleteSelectedItem, isSelected), _defineProperty(_classnames, classes.autocompleteItemSlim, slim), _classnames))
  }, innerProps), children);
}

function Placeholder(props) {
  var _props$selectProps4 = props.selectProps,
      classes = _props$selectProps4.classes,
      slim = _props$selectProps4.slim,
      _props$innerProps = props.innerProps,
      innerProps = _props$innerProps === void 0 ? {} : _props$innerProps,
      children = props.children,
      isFocused = props.isFocused;
  return isFocused ? React.createElement(Typography, Object.assign({
    color: 'textSecondary',
    className: classnames(classes.autocompletePlaceholder, slim ? classes.autocompletePlaceholderSlim : '')
  }, innerProps), children) : null;
}

function SingleValue(props) {
  var children = props.children,
      _props$selectProps5 = props.selectProps,
      classes = _props$selectProps5.classes,
      _props$selectProps5$i = _props$selectProps5.innerProps,
      innerProps = _props$selectProps5$i === void 0 ? {} : _props$selectProps5$i,
      slim = _props$selectProps5.slim;
  return React.createElement(Typography, Object.assign({
    className: classnames(classes.autocompleteSingleValue, slim ? classes.autocompleteSingleValueSlim : '')
  }, innerProps), children);
}

function ValueContainer(props) {
  var children = props.children,
      _props$selectProps6 = props.selectProps,
      classes = _props$selectProps6.classes,
      slim = _props$selectProps6.slim;
  return React.createElement("div", {
    className: classnames(classes.autocompleteValueContainer, _defineProperty({}, classes.autocompleteValueContainerSlim, !!slim))
  }, children);
}

function MultiValue(props) {
  var _classnames3;

  var children = props.children,
      _props$selectProps7 = props.selectProps,
      classes = _props$selectProps7.classes,
      slim = _props$selectProps7.slim,
      isFocused = props.isFocused,
      removeProps = props.removeProps;
  return React.createElement(Chip, {
    tabIndex: -1,
    label: children,
    className: classnames(classes.autocompleteChip, (_classnames3 = {}, _defineProperty(_classnames3, classes.autocompleteChipFocused, isFocused), _defineProperty(_classnames3, classes.autocompleteChipSlim, slim), _classnames3)),
    onDelete: removeProps.onClick,
    classes: {
      label: classnames(_defineProperty({}, classes.autocompleteChipLabelSlim, slim))
    },
    deleteIcon: React.createElement(CancelIcon, Object.assign({
      className: classnames(_defineProperty({}, classes.autocompleteChipDeleteIconSlim, slim))
    }, removeProps, {
      fontSize: slim ? 'small' : 'default'
    }))
  });
}

function Menu(props) {
  var _classnames6;

  var innerRef = props.innerRef,
      children = props.children,
      _props$selectProps8 = props.selectProps,
      classes = _props$selectProps8.classes,
      slim = _props$selectProps8.slim,
      innerProps = props.innerProps,
      placement = props.placement;
  return React.createElement(Paper, Object.assign({
    square: true,
    className: classnames(classes.autocompletePaper, (_classnames6 = {}, _defineProperty(_classnames6, classes.autocompletePaperTopSlim, placement === 'top' && slim), _defineProperty(_classnames6, classes.autocompletePaperTop, placement === 'top'), _classnames6))
  }, innerProps, {
    ref: innerRef
  }), children);
}

var components = {
  Control: Control,
  Menu: Menu,
  MultiValue: MultiValue,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  Placeholder: Placeholder,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var isSomeWithoutLabel = function isSomeWithoutLabel(items) {
  return items.some(function (item) {
    return !item.label;
  });
};

var isSame = function isSame(item1, item2) {
  return item1.value === item2.value || Number(item1.value) === Number(item2.value);
};

var isContains = function isContains(items, item) {
  if (!item) return false;
  return !!items.find(function (componentItem) {
    return isSame(item, componentItem);
  });
};

var emptyMultiValues = [];
export default function Autocomplete(props) {
  var id = props.id,
      required = props.required,
      field = props.field,
      value = props.value,
      disabled = props.disabled,
      error = props.error,
      classes = props.classes,
      slim = props.slim,
      ajax = props.ajax,
      loading = props.ajax.loading,
      onFieldChange = props.onFieldChange,
      preFilterValues = props.preFilterValues,
      labelWidth = props.labelWidth,
      inputLabelRef = props.inputLabelRef;
  var ID = id || field.name;
  /** Поле поддерживает множественный выбор значений */

  var isMulti = [FieldType.MultiAutocomplete, FieldType.AsyncMultiAutocomplete, FieldType.MultiSelect].includes(field.type);
  /** Поле поддерживает асинхронную фильтрацию списка */

  var isAsync = [FieldType.AsyncAutocomplete, FieldType.AsyncMultiAutocomplete].includes(field.type);
  /** Поле поддерживает асинхронную загрузку списка */

  var isFetch = 'params' in field && !!field.params.url;
  var preload = 'params' in field && 'preload' in field.params ? Number(field.params.preload) || 0 : 0;
  var isSelect = [FieldType.Select, FieldType.MultiSelect].includes(field.type);
  /** Автоматически подставлять значение поля, если в полученном списке значений только одно значение.
   * Только для поля Select */

  var isAutoSelect = field.type === FieldType.Select && 'params' in field && field.params.autoSelectBehavior;
  /** Флаг первичной загрузке, используется при сбросе или обновлении значений*/

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isFirstFetch = _useState2[0],
      setIsFirstFetch = _useState2[1];
  /** Значения для multi */


  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      componentValues = _useState4[0],
      setComponentValues = _useState4[1];
  /** Значения для single*/


  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      componentValue = _useState6[0],
      setComponentValue = _useState6[1];
  /** Элементы списка */


  var _useState7 = useState('items' in field ? field.items : []),
      _useState8 = _slicedToArray(_useState7, 2),
      componentItems = _useState8[0],
      setComponentItems = _useState8[1];
  /** Поле заблокировано согласно условию из формы или во время загрузки при инициализации */


  var isDisabled = !!disabled || loading && isFirstFetch;
  /** Устанавливаемое значение*/

  var selectedValue = useMemo(function () {
    if (isMulti) return isArray(value) && value.length > 0 ? value : emptyMultiValues;
    return isObject(value) ? value : null;
  }, [value, isMulti]);
  useDeepEffect(function () {
    // Если получаем список из бэка и он не пустой, то очищаем список
    if (isFetch && componentItems.length > 0) {
      setComponentItems([]);
    } // Если асинхронный поиск


    if (isAsync) {
      if (preload && !disabled) {
        // Загружаем указанное количество записей
        ajax.fetch({
          limit: preload,
          offset: 0
        }, preFilterValues, function (_ref2) {
          var newItems = _ref2.items;
          setComponentItems(isArray(newItems) ? newItems.slice(0, preload) : []);
          setIsFirstFetch(false);
        });
      } else {
        // Переключаем флаг первичной загрузки данных
        setIsFirstFetch(false);
      } // todo дореализовать запрос по label
      // if (defaultValue && isFetch && !isDisabled) {
      //   if(isMulti) {
      //     if (isArray(defaultValue) && defaultValue.length > 0) {
      //
      //     } else {
      //       setIsFirstFetch(false);
      //     }
      //   } else {
      //     if((defaultValue as ClassifierItem).label) {
      //       ajax.fetch(
      //         {},
      //         {
      //           ...filterParams,
      //           value: (defaultValue as ClassifierItem).label
      //         }, ({items: newItems}) => {
      //           setComponentItems(isArray(newItems) ? newItems : []);
      //           setIsFirstFetch(false);
      //         })
      //     } else {
      //       setIsFirstFetch(false);
      //     }
      //   }
      // } else {
      //   setIsFirstFetch(false);
      // }

    } else {
      // Запрашиваем список если есть урл и поле не пусто и заблокировано
      if (isFetch && !(disabled && !value)) {
        ajax.fetch({}, preFilterValues, function (_ref3) {
          var newItems = _ref3.items;
          setComponentItems(isArray(newItems) ? newItems : []);
          setIsFirstFetch(false);
          /**
           * получили массив значений, проверяем на особые случаи
           * если нет выбранного значения и это автоселект - берем первый элемент из списка
           * если это уже не первый запрос списка, есть уже выбранное значение и оно
           * отсутствует в полученном списке, то
           *   в обычной логике - сбрасываем значение в null
           *   для автоселекта - берем первое значение из списка
           * в остальных случаях ничего не делаем и используем выбранное значение
           */

          if (!selectedValue && isAutoSelect) {
            if (isArray(newItems) && newItems.length > 0) onChangeComponentValue(newItems[0]);
          } else if (!isFirstFetch && selectedValue) {
            if (!isContains(newItems, selectedValue)) {
              if (isAutoSelect) onChangeComponentValue(newItems[0]);else onChangeComponentValue(null);
            }
          }
        });
      }
    }
  }, [preFilterValues, disabled]);
  useDeepEffect(function () {
    // Если асинхронный поиск, то значение ставим как есть
    if (isAsync) {
      if (isMulti) {
        setComponentValues(selectedValue);
      } else {
        setComponentValue(selectedValue);
      }
    } else {
      if (componentItems.length > 0) {
        if (isMulti) {
          if (selectedValue.length > 0) {
            // если в selectedValue есть элементы без label, то проводим выборку из
            // componentItems элементов, совпадающих по value с элементами в selectedValue
            var newValue = isSomeWithoutLabel(selectedValue) ? componentItems.filter(function (componentItem) {
              return selectedValue.filter(function (valueItem) {
                return isSame(valueItem, componentItem);
              }).length > 0;
            }) : selectedValue;
            setComponentValues(newValue);
          } else {
            setComponentValues(selectedValue);
          }
        } else {
          if (selectedValue) {
            // если selectedValue без label, то ищем соответствующий элемент в списке
            // иначе устанавливаем выбранное значение
            var _newValue = !selectedValue.label ? componentItems.filter(function (componentItem) {
              return isSame(selectedValue, componentItem);
            })[0] || null : selectedValue;

            setComponentValue(_newValue);
          } else {
            setComponentValue(null);
          }
        }
      } else {
        if (isMulti) {
          setComponentValues(selectedValue);
        } else {
          setComponentValue(selectedValue);
        }
      }
    }
  }, [selectedValue, componentItems]);
  /**
   * Выбор значения из списка
   * @param item
   */

  var onChangeComponentValue = function onChangeComponentValue(item) {
    isMulti ? setComponentValues(item === null ? [] : item) : setComponentValue(item);
    var value = item === null ? undefined : item;
    onFieldChange(ID, value);
  };
  /**
   * Загрузка списка
   * @param inputValue
   * @param callback
   */


  var fetchOptions = useCallback(function (inputValue, callback) {
    var requestFilterParams = !isEmpty(preFilterValues) ? _objectSpread({}, preFilterValues, {
      text: inputValue
    }) : {
      text: inputValue
    };
    return ajax.fetch({}, requestFilterParams, function (_ref4) {
      var items = _ref4.items;
      callback(items);
    });
  }, [ajax, preFilterValues]);
  var inputId = "".concat(isSelect ? 'select' : 'autocomplete', "_").concat(ID);

  var indicatorStyles = function indicatorStyles(provided, _state) {
    return _objectSpread({}, provided, {
      padding: slim ? 0 : '9.1px 8px'
    });
  };

  var customStyles = {
    dropdownIndicator: indicatorStyles,
    loadingIndicator: indicatorStyles,
    clearIndicator: indicatorStyles,
    input: function input(provided, _state) {
      return slim ? _objectSpread({}, provided, {
        color: 'inherit',
        marginTop: 0,
        marginBottom: 0
      }) : _objectSpread({}, provided, {
        color: 'inherit'
      });
    },
    menuList: function menuList(provided, _state) {
      return slim ? _objectSpread({}, provided, {
        paddingTop: 2,
        paddingBottom: 2
      }) : _objectSpread({}, provided);
    }
  };
  var baseProps = {
    // defaultMenuIsOpen: true, //для дебага
    classes: classes,
    inputId: inputId,
    components: components,
    styles: customStyles,
    slim: slim,
    labelWidth: labelWidth,
    TextFieldProps: {
      required: !!required,
      label: field.label,
      error: !!error,
      helperText: error,
      disabled: isDisabled,
      InputLabelProps: {
        ref: inputLabelRef,
        htmlFor: inputId,
        shrink: true
      }
    },
    placeholder: isSelect ? '' : 'placeholder' in field ? field.placeholder : 'Введите текст для поиска',
    noOptionsMessage: function noOptionsMessage() {
      return 'Нет результатов';
    },
    loadingMessage: function loadingMessage() {
      return 'Загрузка';
    },
    isClearable: true,
    isDisabled: isDisabled,
    value: isMulti ? componentValues : componentValue,
    onChange: onChangeComponentValue,
    isMulti: isMulti,
    isSearchable: !isSelect,
    maxMenuHeight: 'params' in field && field.params.maxMenuHeight ? field.params.maxMenuHeight : 300
  };
  return React.createElement("div", {
    className: classes.fieldContainer
  }, React.createElement("div", {
    className: classes.autocompleteRoot
  }, isAsync ? React.createElement(AsyncSelect, Object.assign({}, baseProps, {
    defaultOptions: componentItems,
    cacheOptions: isEmpty(preFilterValues),
    loadOptions: fetchOptions
  })) : React.createElement(Select, Object.assign({}, baseProps, {
    menuPlacement: 'auto',
    // menuPosition="fixed"
    options: componentItems
  }))), loading && isFirstFetch && React.createElement("div", {
    className: classes.fieldLoaderContainer
  }, React.createElement(CircularProgress, {
    className: classnames(classes.fieldLoader, _defineProperty({}, classes.slimFieldLoader, !!slim)),
    size: slim ? 16 : 24,
    thickness: 4
  })));
}